import { useEffect, useState } from 'react';
import { StanButton, StanCard } from '@/components';
import { useAuthStore } from '@/stores';
import { copyToClipboard, createIconElement } from '@/lib';
import { generateReferralUrl } from '../logic/referrals.logic';
import HeartIcon from '@/assets/icons/ic-heart.svg';
import CopyIcon from '@/assets/icons/ic-copy.svg';

const heartIcon = createIconElement(HeartIcon);
const copyIcon = createIconElement(CopyIcon, { className: 'size-5' });

export function ShareReferralLink() {
    const [referralUrl, setReferralUrl] = useState('');
    const { currentAccount } = useAuthStore();
    const accountData = currentAccount();

    useEffect(() => {
        if (accountData?.username) {
            const generatedUrl = generateReferralUrl(accountData.username, false); // false for staging
            setReferralUrl(generatedUrl);
        }
    }, [accountData?.username]);

    const handleCopyLink = () => {
        copyToClipboard(referralUrl, {
            successMessage: 'Referral link copied to clipboard',
            errorMessage: 'Failed to copy link to clipboard',
        });
    };

    return (
        <StanCard className='w-full'>
            <div className='flex w-full flex-col items-center gap-4 md:flex-row md:justify-between md:gap-0'>
                {/* Title Row */}
                <div className='text-dark flex items-center gap-3'>
                    {heartIcon}
                    <h3 className='text-heading-h3'>Share Referral Link</h3>
                </div>

                {/* Link and Copy Button */}
                <div className='flex w-full flex-col items-center gap-3 md:w-auto md:flex-row'>
                    <a
                        href={referralUrl}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-brand-main text-label-md-bold md:text-heading-h3 cursor-pointer text-center hover:underline'
                    >
                        {referralUrl.replace('https://', '')}
                    </a>
                    <StanButton
                        name='copy-referral-link'
                        color='secondary'
                        size='md'
                        onClick={handleCopyLink}
                        icon={copyIcon}
                        className='w-full md:w-auto'
                    >
                        Copy
                    </StanButton>
                </div>
            </div>
        </StanCard>
    );
}
